import React, { lazy, useEffect, useRef, useState } from 'react';
import SectionSkeleton from './sectionskeleton';
import LazySection from 'components/lazySection';
import { useLocation } from 'react-router-dom';
import TeamStories from 'components/career-newv/CareerStoriesTeam';
import CoreValuesAndLeadership from 'components/career-newv/CareerValue';
import CareerTeamDetail from 'components/career-newv/CareerTeamDetail';
import CareerFaq from 'components/career-newv/Careerfaq';
import CareerInfo from 'components/career-newv/CareerInfo';
import { getCareerCoreValues } from 'components/Service/CareerApi';

const CareerBanner      = lazy(() => import("../components/career-newv/CareerBanner"));
const CareerJobOpenings = lazy(() => import("../components/career-newv/CareerJobOpenings"));

const uid = 'e648b653-d2c7-4811-853d-c8862ccec8a8';

const Career: React.FC = () => {
  const location  = useLocation();
  const modalRef  = useRef<any>(null);

  const [node, setNode]               = useState<any>(null);
  const [modalReady, setModalReady]   = useState(false);  // ✅ modal open state
  const [showPage, setShowPage]       = useState(false);  // ✅ page content state
  const getCookie = (name: string) => {
  const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) {
        return parts.pop()?.split(";").shift();
      }
      return null;
    };
    const setCookie = (name: string, value: string, days: number) => {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);

      document.cookie = `${name}=${value}; expires=${date.toUTCString()}; path=/`;
    };
const shouldShowModal = () => {
  const lastShown = localStorage.getItem('careerModalDate');
  const today     = new Date().toDateString(); // "Thu Jul 10 2026"

  if(!lastShown){
    return true; // ✅ already shown today
  }
  return false; // ✅ show today
};
  // ✅ STEP 1: Open modal immediately on mount
  useEffect(() => {
    if(!shouldShowModal()) return; // ✅ skip if shown today
  //  if (getCookie("careerPopupShown")) {
  //   return; // Cookie exists, don't show popup
  // }
    const timer = setTimeout(() => {
      const modalEl = document.getElementById('careermodal');
      if(modalEl){
        modalRef.current = new (window as any).bootstrap.Modal(modalEl, {
          backdrop: 'static',
          keyboard: false
        });
        modalRef.current.show();
        setModalReady(true); // ✅ modal is open
        localStorage.setItem('careerModalDate', new Date().toDateString());
        // setCookie("careerPopupShown", "true", 365);
      }
    }, 100); // ✅ open fast

    return () => clearTimeout(timer);
  }, []); // ✅ runs immediately on mount

  // ✅ STEP 2: Fetch node data
  useEffect(() => {
    getCareerCoreValues(uid)
      .then((res) => {
        setNode(res.data); // ✅ set node after fetch
      })
      .catch(console.error);
  }, []);

  // ✅ STEP 3: Close modal and show page
  const closeModal = () => {
    if(modalRef.current){
      modalRef.current.hide();
      setShowPage(true); // ✅ show page after close
    }
  };

  // ✅ Hash scroll
  useEffect(() => {
    if(!location.hash) return;

    let attempts    = 0;
    const maxAttempts = 20;

    const scrollToHash = () => {
      const element = document.querySelector(location.hash);
      if(element){
        const y = element.getBoundingClientRect().top + window.pageYOffset - 120;
        window.scrollTo({ top: y, behavior: "smooth" });
      } else if(attempts < maxAttempts){
        attempts++;
        setTimeout(scrollToHash, 150);
      }
    };
    setTimeout(scrollToHash, 100);
  }, [location.pathname, location.hash]);

  return (
    <>
      {/* ✅ STEP 1: Modal shows first */}
      <div
        className="modal fade"
        id="careermodal"
        tabIndex={-1}
        aria-labelledby="sendUsdetailLabel"
        aria-hidden="true"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
      >
        <div
          className="modal-dialog modal-dialog-centered"
          style={{
            ['--bs-modal-width' as any]: '600px',
            maxWidth: 'var(--bs-modal-width)',
          }}
        >
          <div className="modal-content modal-md p-4">

            <div className="modal-body p-0">
              <div className="row pb-2">
                {/* ✅ Show loader while node fetching */}
                {!node ? (
                  <div className="col-12 text-center py-4">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                ) : (
                  <div
                    className="col-12"
                    dangerouslySetInnerHTML={{
                      __html: node?.attributes?.field_content?.value ?? ''
                    }}
                  />
                )}
              </div>
            </div>

            <div className="modal-footer p-0 pt-2">
              {/* ✅ Disable close until content loaded */}
              <button
                type="button"
                className="btn btn-sm btn-outline-primary rounded-pill"
                onClick={closeModal}
                disabled={!node} // ✅ disable until node loads
              >
                {!node ? 'Loading...' : 'Close'}
              </button>
            </div>

          </div>
        </div>
      </div>

      {/* ✅ STEP 2: Page loads after modal */}
      <CareerBanner />
      <CoreValuesAndLeadership />
      <CareerTeamDetail />
      <TeamStories />
      <CareerFaq />
      <CareerJobOpenings />
      <CareerInfo />
    </>
  );
};

export default Career;